import { createSlice } from '@reduxjs/toolkit';
import { searchReducer as extraReducers } from '../reducers';
import { ISearchState } from '../../interfaces';
import { searchAction } from '../actions';

const initialState: ISearchState = {
  status: 'inactive',
  faqs: [],
  categories: [],
  options: [],
  suboptions: [],
  error: '',
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  // Non-async reducers
  reducers: {
    resetSearch: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const searchSliceActions = { ...searchSlice.actions, ...searchAction };

export default searchSlice.reducer;
